import { matchPath } from 'react-router';

import { PageTags, Params } from './types';

class CustomerPageTags extends PageTags {
  static get({ pathname, exact }: Params) {
    let currentPage = '';
    // eslint-disable-next-line no-restricted-syntax
    for (const [path] of Object.entries(this.container)) {
      const currentRoutePath = matchPath(pathname, { path, exact });
      if (currentRoutePath) {
        currentPage = path;
        break;
      }
    }

    if (this.container[currentPage]) {
      return this.container[currentPage];
    }
    return undefined;
  }

  static get container(): {[key: string]: string[]} {
    return {
      '/dashboard/admin/customers': this.customers,
      '/dashboard/admin/customers/:id': this.overview,
    };
  }

  static get customers() {
    return [
      'tag:customer',
      'tag:list',
    ];
  }

  static get overview() {
    return [
      'tag:customer',
      'tag:detail',
    ];
  }
}


export default CustomerPageTags;
